module.exports = __webpack_public_path__ + "img/case_baidu_netdisk.0f9877d8.png";